import sortBy from 'lodash/sortBy'

import type Survey from 'modules/surveys/store/models/v2/Survey'

// Draft > Active > Finished
export const sortByStatusAsc = (filtered: Survey[]): Survey[] => {
  return sortBy(filtered, (form: Survey) => {
    if (form.isDraft) return -1

    if (form.isActive) return 0

    return 1
  })
}

// Finished > Active > Draft
export const sortByStatusDesc = (filtered: Survey[]): Survey[] => {
  return sortBy(filtered, (form: Survey) => {
    if (form.isFinished) return -1

    if (form.isActive) return 0

    return 1
  })
}
